export default __webpack_public_path__ + "static/media/math-formula-blue.bcc2b9c4.svg";